export default "__VITE_ASSET__cyqX5BLu__"